import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { TypeCoordComponent } from './typeCoord/type-coord.component';
import { TypePersComponent } from './typePers/type-pers.component';
import { TypeAdresseComponent } from './typeAdresse/type-adresse.component';
import { TypeAdresseCompleteObligatoireComponent } from './typeAdresseCompleteObligatoire/type-adresse-complete-obligatoire.component';
import { ClasseProfitComponent } from './classeProfit/classe-profit.component';
import { TypeOuiNonComponent } from './typeOuiNon/type-oui-non.component';
import { TypeVoieComponent } from './typeVoie/type-voie.component';
import { TypeAdresseTEMPOSTComponent } from './typeAdresseTEMPOST/type-adresseTEMPOST.component';
import { Step1CommonComponent } from './steps/step1/step1common.component';
import { TypeMotsClefComponent } from './typeMotsClef/type-mots-clef.component';


@NgModule({
  declarations: [
    TypeCoordComponent,
    TypePersComponent,
    TypeAdresseComponent,
    TypeAdresseCompleteObligatoireComponent,
    ClasseProfitComponent,
    TypeOuiNonComponent,
    TypeVoieComponent,
    TypeAdresseTEMPOSTComponent,
    TypeMotsClefComponent,
    Step1CommonComponent,
  ],
  exports: [Step1CommonComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
})
export class FormDiversCommonModule { }
